import React, { useEffect, useState } from 'react';
import { useSnackbar } from 'notistack';
import { Controller } from 'react-hook-form';
import TextField from '@mui/material/TextField';
import InputAdornment from '@mui/material/InputAdornment';
import { Box, CircularProgress, Typography } from '@mui/material';
import Iconify from '../Iconify';
import { networkGetUploadToServerBasePath } from 'src/network/server-management';

const CHUNK_SIZE = 5 * 1024 * 1024; // 5 MB

const GeneralVideoUploader = ({ name, label, id, afterChangeAction, isCompleted, setIsCompleted }) => {
  const [basePath, setBasePath] = useState('');
  const [isLoading, setIsLoading] = useState(false);

  const [progress, setProgress] = useState(0);
  const [isUploading, setIsUploading] = useState(false);

  const { enqueueSnackbar } = useSnackbar();

  const handleChangeFile = async (files) => {
    const fileInput = document.getElementById(id);

    const file = files[0];

    if (!file) {
      enqueueSnackbar('لطفا محتوای موردنظر را انتخاب کنید', { variant: 'error' });
      return;
    }

    setIsUploading(true);

    const fileName = file.name;
    const fileSize = file.size;

    try {
      const initResponse = await fetch('https://up1.dooorbin.com/upload/init', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          path: basePath + fileName,
          game: 0,
        }),
      });

      if (!initResponse.ok) {
        setIsUploading(false);
        if (initResponse.status === 401) {
          enqueueSnackbar('آیپی شما معتبر نیست!', { variant: 'error' });
        }
        return;
      }

      const initData = await initResponse.json();
      const fileId = initData.file_id;

      await uploadFile(file, fileId, fileSize);
    } catch (error) {
      setIsUploading(false);
      enqueueSnackbar('مشکلی پیش آمده است، لطفااز دوباره امتحان کنید', { variant: 'error' });
    } finally {
      // پاک کردن مقدار input فایل بعد از انتخاب فایل
      fileInput.value = null;
    }
  };

  const uploadFile = async (file, fileId, fileSize) => {
    let start = 0;

    while (start < fileSize) {
      const end = Math.min(start + CHUNK_SIZE, fileSize);
      const chunk = file.slice(start, end);

      const formData = new FormData();
      formData.append('file_id', fileId);
      formData.append('chunk', chunk);

      let status = false;
      while (!status) {
        const chunkResponse = await fetch('https://up1.dooorbin.com/upload/chunk', {
          method: 'POST',
          body: formData,
        });

        if (!chunkResponse.ok) {
          status = false;
        } else {
          status = true;
        }
      }

      start = end;
      updateProgress(start, fileSize);
    }

    const completeResponse = await fetch('https://up1.dooorbin.com/upload/complete', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ file_id: fileId }),
    });

    const res = await completeResponse.json();

    if (completeResponse.ok) {
      enqueueSnackbar('محتوای موردنظر با موفقیت آپلود شد');
      setIsCompleted(true);
      afterChangeAction(res);
    } else {
      enqueueSnackbar('خظا در آپلود، لطفااز دوباره امتحان کنید', { variant: 'error' });
    }
    setIsUploading(false);
  };

  const updateProgress = (loaded, total) => {
    const percent = Math.round((loaded / total) * 100);
    setProgress(percent);
  };

  const onGeBasePath = () => {
    setIsLoading(true);
    networkGetUploadToServerBasePath()
      .then((res) => setBasePath(res?.data?.BasePath))
      .catch((error) => console.log(error))
      .finally(() => setIsLoading(false));
  };

  useEffect(() => {
    onGeBasePath();
  }, []);

  if (isLoading) return null;

  return (
    <div>
      <Controller
        name={name}
        render={({ field }) => (
          <TextField
            dir="ltr"
            fullWidth
            variant="outlined"
            label={label}
            value={field.value || ''}
            InputProps={{
              endAdornment: (
                <InputAdornment position="end">
                  <input
                    id={id}
                    type="file"
                    style={{ display: 'none' }}
                    onChange={(e) => {
                      handleChangeFile(e.target.files);
                    }}
                  />
                  <label htmlFor={id} className="cursor-pointer absolute left-2">
                    {isUploading || isCompleted ? (
                      <>
                        {isUploading ? (
                          <Box position="relative" display="inline-flex" mt={1}>
                            <CircularProgress size={40} variant="determinate" value={progress} thickness={2} />
                            <Box
                              top={0}
                              left={0}
                              bottom={0}
                              right={0}
                              position="absolute"
                              display="flex"
                              alignItems="center"
                              justifyContent="center"
                            >
                              <Typography variant="button" component="div" color="textSecondary">{`${progress}%`}</Typography>
                            </Box>
                          </Box>
                        ) : isCompleted ? (
                          <Iconify width={28} height={28} icon="pajamas:check-circle-filled" color="#0caa5e" />
                        ) : null}
                      </>
                    ) : (
                      <Iconify width={30} height={30} icon="ep:upload-filled" />
                    )}
                  </label>
                </InputAdornment>
              ),
              sx: { paddingRight: '45px' },
            }}
            {...field}
          />
        )}
      />
    </div>
  );
};

export default GeneralVideoUploader;
